export default __webpack_public_path__ + "static/media/user-edit.c7c788e3.svg";